import React from 'react';
import { useEffect } from 'react';
import useSentry from './useSentry';

const Sentry: React.FC = () => {
  const [initSentry] = useSentry();

  useEffect(() => {
    initSentry();
  }, [initSentry]);

  return <></>;
};

export default Sentry;
